import { getAccountValue } from '@op/components/FilterCommon/utils/monitorUtil';
import { useFilterCondConf } from '@op/hooks/useFilterCondConf';
import { gameInfoType } from '@op/types/common';
import { useMemo } from 'react';

export function useAccountFilter({ gameInfo }: { gameInfo: gameInfoType }) {
  const { loading: condLoading, monitor_by_account_category } =
    useFilterCondConf({
      gameInfo,
      requestList: [{ key: 'monitor_by_account_category', defaultValue: {} }],
    });

  const { exceptPrivateFilter, officialAccountsFilter } = useMemo(() => {
    const { monitory } = monitor_by_account_category;

    if (!monitory) {
      return {
        exceptPrivateFilter: {},
        officialAccountsFilter: {},
      };
    }
    const exMonitor = monitory['private-channels'];
    const exList = exMonitor.map((item: any) => getAccountValue(item));

    const monitor = monitory['official-accounts'];
    const list = monitor.map((item: any) => getAccountValue(item));

    return {
      exceptPrivateFilter: { except_social_media_by_account: exList },
      officialAccountsFilter: { social_media_by_account: list },
    };
  }, [monitor_by_account_category]);

  return {
    exceptPrivateFilter,
    condLoading,
    officialAccountsFilter,
  };
}
